module.exports = "/_next/static/images/circlestar-line-bb4b217979207946fb5fbf87367e0eb8.svg";